import {
  Layers as LayersIcon,
  Shield as ShieldIcon,
  Share2 as Share2Icon,
  Users as UsersIcon,
} from 'react-feather'
import { DataUsage as DataUsageIcon } from '@material-ui/icons'

import dataProcessConstants from 'constants/dataProcess'
import dataCollectedConstants from 'constants/dataCollected'
import agentsConstants from 'constants/dataTreatmentAgents'
import theme from 'theme'

const {
  STORY_MODE_DEFINED_TYPE,
  STORY_MODE_PERMANENT_TYPE,
  STORY_MODE_UNDEFINED_TYPE,
} = dataProcessConstants

const DASHBOARD_MAIN_TAB = 'dashboard-main-tab'
const DASHBOARD_GENERAL_INFORMATION_TAB = 'dashboard-general-information-tab'
const DASHBOARD_SAFEGUARD_TAB = 'dashboard-safeguard-tab'
const DASHBOARD_SHARED_DATA_TAB = 'dashboard-shared-data-tab'
const DASHBOARD_TREATMENT_AGENT_TAB = 'dashboard-treatment-agent-tab'

const DASHBOARD_TAB_ITEMS = [
  {
    value: DASHBOARD_MAIN_TAB,
    label: 'Todos',
    Icon: DataUsageIcon,
  },
  {
    value: DASHBOARD_GENERAL_INFORMATION_TAB,
    label: 'Informações Gerais',
    Icon: LayersIcon,
  },
  {
    value: DASHBOARD_SAFEGUARD_TAB,
    label: 'Salvaguardas',
    Icon: ShieldIcon,
  },
  {
    value: DASHBOARD_SHARED_DATA_TAB,
    label: 'Compartilhamento',
    Icon: Share2Icon,
  },
  {
    value: DASHBOARD_TREATMENT_AGENT_TAB,
    label: 'Agentes de Tratamento',
    Icon: UsersIcon,
  },
]

const TITULAR_AGE_RANGES_CARD_ITEMS = [
  {
    titularAgeRanges: dataCollectedConstants.CHILD_ID,
    subTitle: 'Processos com dados de crianças',
    Icon: UsersIcon,
    iconBgColor: theme.palette.grapePurple,
  },
  {
    titularAgeRanges: dataCollectedConstants.ADOLESCENT_ID,
    subTitle: 'Processos com dados de adolescentes',
    Icon: UsersIcon,
    iconBgColor: theme.palette.primary.hover,
  },
  {
    titularAgeRanges: dataCollectedConstants.ADULT_ID,
    subTitle: 'Processos com dados de adultos',
    Icon: UsersIcon,
    iconBgColor: theme.palette.tertiary.main,
  },
  {
    titularAgeRanges: dataCollectedConstants.ELDERLY_ID,
    subTitle: 'Processos com dados de idosos',
    Icon: UsersIcon,
    iconBgColor: theme.palette.warning.main,
  },
]

const GENERAL_INFORMATION_DEPARTMENTS_TABLE = [
  {
    key: 'name',
    label: 'Departamento',
    width: '80%',
  },
  {
    key: 'quantity',
    label: 'Processos',
    width: '20%',
    align: 'center',
    highlight: true,
  },
]

const GENERAL_INFORMATION_DATA_ORIGIN_TABLE = [
  {
    key: 'sourceDescription',
    label: 'Local',
    width: '80%',
  },
  {
    key: 'quantity',
    label: 'Processos',
    align: 'center',
    width: '20%',
    highlight: true,
  },
  { key: 'action', label: 'Ação', width: '10%', align: 'center' },
]

const STORAGE_MODES_ORDER = [
  STORY_MODE_DEFINED_TYPE,
  STORY_MODE_UNDEFINED_TYPE,
  STORY_MODE_PERMANENT_TYPE,
]

const TREATED_DATA_TABLE = [
  {
    key: 'name',
    label: 'Dados tratados',
    width: '80%',
  },
  {
    key: 'quantity',
    label: 'Processos',
    align: 'center',
    width: '20%',
    highlight: true,
  },
]

const TREATED_DATA_TITULAR_CATEGORY_TABLE = [
  {
    key: 'name',
    label: 'Categoria de titulares',
    width: '80%',
  },
  {
    key: 'quantity',
    label: 'Processos',
    align: 'center',
    width: '20%',
    highlight: true,
  },
]

const TREATED_DATA_BY_DATA_TYPE_OPTIONS = [
  { key: 'sensitive', id: 1 },
  { key: 'personal', id: 2 },
  { key: 'financial', id: 3 },
  { key: 'behavioral', id: 4 },
]

const TREATED_DATA_BY_DATA_TYPE_TABLE = [
  {
    key: 'name',
    label: 'Categoria do titular',
    width: '50%',
  },
  {
    key: 'sensitive',
    label: 'Sensíveis',
    width: '10%',
    align: 'center',
    highlight: true,
  },
  {
    key: 'personal',
    label: 'Pessoais',
    width: '10%',
    align: 'center',
    highlight: true,
  },
  {
    key: 'financial',
    label: 'Financeiros',
    width: '10%',
    align: 'center',
    highlight: true,
  },
  {
    key: 'behavioral',
    label: 'Comportamentais',
    width: '10%',
    align: 'center',
    highlight: true,
  },
]

const LIFECYCLE_ASSET_INVENTORY_CATEGORY_TABLE = [
  {
    key: 'name',
    label: 'Categoria de ativos',
    width: '80%',
  },
  {
    key: 'quantity',
    label: 'Processos',
    align: 'center',
    width: '20%',
    highlight: true,
  },
]

const LIFECYCLE_DISCARD_MODE_TABLE = [
  {
    key: 'name',
    label: 'Disposição dos dados',
    width: '80%',
  },
  {
    key: 'quantity',
    label: 'Processos',
    align: 'center',
    width: '20%',
    highlight: true,
  },
]

const LIFECYCLE_RECOVERY_TABLE = [
  {
    key: 'name',
    label: 'Forma de recuperação',
    width: '80%',
  },
  {
    key: 'quantity',
    label: 'Processos',
    align: 'center',
    width: '20%',
    highlight: true,
  },
]

const SHARED_DATA_TABLE = [
  {
    key: 'name',
    label: 'Compartilhado com',
    width: '80%',
  },
  {
    key: 'quantity',
    label: 'Processos',
    align: 'center',
    width: '20%',
    highlight: true,
  },
]

const SHARED_DATA_COUNTRIES_TABLE = [
  {
    key: 'country',
    label: 'País',
    width: '80%',
  },
  {
    key: 'quantity',
    label: 'Processos',
    align: 'center',
    width: '20%',
    highlight: true,
  },
]

const SHARED_DATA_SOFTWARES_TABLE = [
  {
    key: 'name',
    label: 'Sistema',
    width: '80%',
  },
  {
    key: 'quantity',
    label: 'Processos',
    align: 'center',
    width: '20%',
    highlight: true,
  },
]

const LEGAL_FRAMEWORK_TABLE = [
  {
    key: 'name',
    label: 'Enquadramento legal',
    width: '80%',
  },
  {
    key: 'quantity',
    label: 'Processos',
    align: 'center',
    width: '20%',
    highlight: true,
  },
]

const TREATMENT_AGENTS_TABLE = [
  {
    key: 'name',
    label: 'Empresa',
    width: '50%',
  },
  {
    key: 'agentType',
    label: 'Papel',
    width: '35%',
    highlight: true,
  },
  {
    key: 'quantity',
    label: 'Processos',
    align: 'center',
    width: '15%',
    highlight: true,
  },
]

const DETAILS_TREATMENT_AGENTS_TABLE = [
  {
    key: 'name',
    label: 'Empresa',
    width: '45%',
  },
  {
    key: agentsConstants.CONTROLLER_TYPE,
    label: agentsConstants.CONTROLLER_LABEL,
    width: '10%',
    align: 'center',
    highlight: true,
  },
  {
    key: agentsConstants.OPERATOR_TYPE,
    label: agentsConstants.OPERATOR_LABEL,
    width: '10%',
    align: 'center',
    highlight: true,
  },
  {
    key: agentsConstants.SUBOPERATOR_TYPE,
    label: agentsConstants.SUBOPERATOR_LABEL,
    width: '15%',
    align: 'center',
    highlight: true,
  },
  {
    key: agentsConstants.CO_CONTROLLER_TYPE,
    label: agentsConstants.CO_CONTROLLER_LABEL,
    width: '15%',
    align: 'center',
    highlight: true,
  },
]

const DATA_INTELLIGENCE_MAIN_DRIVER_STEP_0 =
  'data-intelligence-main-driver-step-0'

const DATA_INTELLIGENCE_MAIN_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + DATA_INTELLIGENCE_MAIN_DRIVER_STEP_0,
    popover: {
      description:
        'A tela de <strong>Inteligência de Dados</strong> contém todos os dados relacionados aos processos. É um módulo <strong>interativo</strong>, que permite filtrar qualquer informação e obter resultados específicos',
    },
  },
]

export default {
  DASHBOARD_GENERAL_INFORMATION_TAB,
  DASHBOARD_MAIN_TAB,
  DASHBOARD_SAFEGUARD_TAB,
  DASHBOARD_SHARED_DATA_TAB,
  DASHBOARD_TAB_ITEMS,
  DASHBOARD_TREATMENT_AGENT_TAB,
  DATA_INTELLIGENCE_MAIN_DRIVER_STEP_0,
  DATA_INTELLIGENCE_MAIN_DRIVER_STEPS_OBJECT,
  DETAILS_TREATMENT_AGENTS_TABLE,
  GENERAL_INFORMATION_DATA_ORIGIN_TABLE,
  GENERAL_INFORMATION_DEPARTMENTS_TABLE,
  LEGAL_FRAMEWORK_TABLE,
  LIFECYCLE_ASSET_INVENTORY_CATEGORY_TABLE,
  LIFECYCLE_DISCARD_MODE_TABLE,
  LIFECYCLE_RECOVERY_TABLE,
  SHARED_DATA_COUNTRIES_TABLE,
  SHARED_DATA_SOFTWARES_TABLE,
  SHARED_DATA_TABLE,
  STORAGE_MODES_ORDER,
  TITULAR_AGE_RANGES_CARD_ITEMS,
  TREATED_DATA_BY_DATA_TYPE_OPTIONS,
  TREATED_DATA_BY_DATA_TYPE_TABLE,
  TREATED_DATA_TABLE,
  TREATED_DATA_TITULAR_CATEGORY_TABLE,
  TREATMENT_AGENTS_TABLE,
}
